import { SPECIAL_USERS, ROLES } from "../../../utils/constants";

const ALLOWED_USERS = [SPECIAL_USERS.shilan, SPECIAL_USERS.maria_antunes, SPECIAL_USERS.filipa_nfb_director];
const ALLOWED_ROLES = [ROLES.admin, ROLES.tech_admin];

const canSeeAllNotes = (userId?: string, roleId?: string) => {
	const isAllowedUser = !!userId && ALLOWED_USERS.includes(userId);
	const isAllowedRole = !!roleId && ALLOWED_ROLES.includes(roleId);
	return isAllowedUser || isAllowedRole;
};

const CLIENT_OWNER_ROLES = [ROLES.theurapist, ROLES.nfb_techncians, ROLES.nfb_and_theurapist, ROLES.client_owner];

const canSeeClientOwnerNotes = (roleId?: string) => {
	const isClientOwnerRole = !!roleId && CLIENT_OWNER_ROLES.includes(roleId);
	return isClientOwnerRole;
};

const CUSTOMER_SUPPORT_ROLES = [ROLES.recepcionist, ROLES.back_office];

const canSeeCustomerSupportNotes = (userId?: string, roleId?: string, treatmentClientOwnerId?: string) => {
	const isTreatmentClientOwner = !!userId && !!treatmentClientOwnerId && userId === treatmentClientOwnerId;
	const isCustomerSupportRole = !!roleId && CUSTOMER_SUPPORT_ROLES.includes(roleId);

	return isTreatmentClientOwner || isCustomerSupportRole;
};

export const getAllowedCategories = (userId?: string, roleId?: string, treatmentClientOwnerId?: string) => {
	if (canSeeAllNotes(userId, roleId)) {
		const allCategories = ["geral", "customer_support", "client_owner"];
		return allCategories;
	}

	const categories: Array<string> = [];

	if (canSeeCustomerSupportNotes(userId, roleId, treatmentClientOwnerId)) {
		categories.push("customer_support");
	}

	if (canSeeClientOwnerNotes(roleId)) {
		categories.push("client_owner");
	}

	return categories;
};
